<template>
    <div class="class" style="display:block;">
        <a class="apply">我申请的班级</a>
        <div
            v-show="classes.length == 0"
            style="position:absolute;top: 200px;left: 500px;"
        >还没有申请加入班级，快去加入吧</div>
        <ul class="ul1" v-show="classes.length > 0">
            <li v-for="(list,index) in classes" :key="index" style="position:relative;">
                <pic :src="list.logoUrl" alt="加载失败" />
                <div class="join">
                    <router-link :to="'/class/'+ list.id">
                        <p>
                            {{list.name}}({{list.occupationName}} | {{list.gradeName}})
                            <span
                                class="checkStatus"
                                :class="'checkStatus-' + list.checkStatus"
                            >{{checkStatus(list.checkStatus)}}</span>
                        </p>
                        <p>学习周期：{{list.beginTime}} - {{list.endTime}}</p>
                        <p>地点：{{list.address}}</p>
                        <p>授课教师：{{list.teacherName}}</p>
                        <p>报名人数：{{list.enrolment}}</p>
                        <el-button
                            type="primary"
                            style="position:absolute;right:100px;width:100px;height:30px;top:80px;"
                        >{{list.progressText}}</el-button>
                    </router-link>
                </div>
            </li>
        </ul>
    </div>
</template>
<script>
export default {
    name: 'myClass',
    data() {
        return {
            classes: []
        }
    },
    created() {
        this.getJoin()
    },
    methods: {
        // 我加入的班级
        getJoin() {
            let platformId = localStorage.getItem('datas')
            this.$axios
                .get(this.$managePath + '/offline/api/class/', platformId)
                .then(res => {
                    if (res.data.data.length == 0) {
                    } else {
                        this.classes = res.data.data
                    }
                })
        },
        checkStatus(status) {
            if (status == 0) {
                return '待审核'
            }
            if (status == 1) {
                return '已通过审核'
            }
            return '申请被驳回'
        }
    }
}
</script>
<style scoped>
@import '../../assets/css/iconfont.css';
@import '../../assets/css/common.css';
@import '../../assets/css/index.css';
@import '../../assets/css/cms.css';
.checkStatus {
    margin-left: 10px;
    font-size: 14px;
}
.checkStatus-0 {
    color: #6b6b6b;
}
.checkStatus-1 {
    color: #2fa973;
}
.checkStatus-2 {
    color: #dd6161;
}
</style>



// WEBPACK FOOTER //
// src/views/mySpace/myClass.vue